export default __webpack_public_path__ + "static/stock-image-1-baa47e9bf09f424f9472461e65e1f03c.png";